// requests the app is waiting for right now (answers, photo uploads, anything over XMLHttpRequest,
// which axios uses): a reload for a new version waits until there are none
let open = 0

export function requestsInFlight(): number {
  return open
}

export function trackRequestsInFlight(): void {
  if (typeof XMLHttpRequest === 'undefined' || (XMLHttpRequest.prototype as any).inFlightTracked) return
  const { send } = XMLHttpRequest.prototype
  XMLHttpRequest.prototype.send = function sendTracked(...args) {
    open++
    this.addEventListener('loadend', () => { open = Math.max(0, open - 1) }, { once: true })
    return send.apply(this, args)
  }
  ;(XMLHttpRequest.prototype as any).inFlightTracked = true
}
